import { useQuery } from '@tanstack/react-query';
import { QUERY_CACHE_CONFIG } from 'configs/queryCache';
import { UserWalletCompanyInfoService } from 'services/openapi';

import { CompanyWalletServiceQueryKeys } from '../constants';
import { GetListCompanyEntity } from '../../openapi/models/GetListCompanyEntity';

export const useGetCompanyAllQuery = () => {
  const queryKey = [CompanyWalletServiceQueryKeys.GET_COMPANY_INFO];

  const {
    isLoading,
    error,
    data,
    isError,
    isFetching,
    isLoadingError,
    refetch,
  } = useQuery<GetListCompanyEntity, Error>({
    queryKey,
    queryFn: () => UserWalletCompanyInfoService.companyControllerFindAll(),
    ...QUERY_CACHE_CONFIG.COMPANY,
    retry: 0,
    refetchOnWindowFocus: false,
    keepPreviousData: true,
  });

  return {
    isLoading,
    isLoadingError,
    isFetching,
    error,
    data: data?.data,
    isError,
    queryKey,
    refetch,
  };
};
